import React from 'react';

import GaPocket from 'apps/auth/components/ga/accounts/GaPocket';
import LibrePocket from 'apps/auth/components/ga/accounts/LibrePocket';
import BasePage from 'apps/auth/components/utils/BasePage';
import { useExtra } from 'apps/auth/hooks/selectors';

const PocketPage = () => {
    const { isLibre } = useExtra();

    return <>{isLibre ? <LibrePocket /> : <GaPocket />}</>;
};
export default BasePage(PocketPage);
